module.exports = __webpack_public_path__ + "img/20191211163537360截图20191211162249780.b5d08b52.jpg";